module.exports = __webpack_public_path__ + "img/21n.09a58374.png";